import React from 'react';
import Gnb from '../components/Gnb';
import Immutable from 'immutable';
import NotLoggedIn from '../components/ErrorContent/NotLoggedIn';

const LoggedOutPage = ({ device }) => (
  <div style={{ height: '100%' }}>
    <div id="kakaoWrap">
      <div id="kakaoHead" className="head_bridge" role="banner">
        <h1 className="tit_logo">
          <a href="#none" style={{ padding: 0 }} className="link_logo">
            <span className="ico_plus ico_logo">카카오톡 채널</span>
          </a>
        </h1>
      </div>
      <hr className="hide" />
      {/* 톡연동 : .cont_inter */}
      <NotLoggedIn />
    </div>
  </div>
)

export default LoggedOutPage;



// WEBPACK FOOTER //
// ./src/containers/NotLoggedInPage.js